export default {
      id: "close-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#close",
      toString: function () {
        return this.url;
      }
    }